export default __webpack_public_path__ + "static/media/short.119c7cd6.svg";